import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

@inject('decorationStore')
@observer
export default class extends Component {
  onChange = () => {
    this.props.onChange(this.props.id)
  }

  render() {
    const {
      decorationStore: { themeConfig },
      name,
      active,
      id
    } = this.props

    const isActive = active == id

    return (
      <div
        style={{
          width: 58,
          height: 32,
          lineHeight: '32px',
          textAlign: 'center',
          color: isActive ? '#fff' : '#333',
          marginRight: 4,
          flexShrink: 0,
          marginBottom: 10,
          backgroundImage: isActive && themeConfig['btn'],
          backgroundColor: !isActive && '#f5f5f5',
          borderRadius: 15
        }}
        onClick={this.onChange}
      >
        {name}
      </div>
    )
  }
}
